// Converted to custom CSS classes (Tailwind removed)
import { Link, useLocation } from "react-router-dom";

const NavBar = () => {
  const { pathname } = useLocation();

  // If you ever need to preserve a return path you can append ?redirect=pathname
  const loginPath = "/login"; // could be `${'/login'}?redirect=${encodeURIComponent(pathname)}` if desired
  const registerPath = "/register";

  return (
    <nav className="lp-navbar">
      <div className="lp-container lp-navbar-inner">
        <img alt="cytailor logo" src="/logo1.png" className="lp-nav-logo" />
        <div className="lp-nav-links">
          <Link to={loginPath} className="lp-nav-signin">
            Sign In
          </Link>
          <Link to={registerPath} className="lp-nav-cta">
            Get Started
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
